export const MINUTE_MS = 60_000;

// Округляет timestamp (мс) до ближайшей минуты: секунды 30 и более
// поднимают минуту на 1. Используется везде, где отображение времени
// экспирации должно совпадать по минутам (поле Time и линия на графике).
export const roundToMinute = (timestampMs: number): number =>
  Math.round(timestampMs / MINUTE_MS) * MINUTE_MS;
